import { Fragment, createElement, useEffect } from 'react';
import { type RouteObject, useSearchParams } from 'react-router';

import { ErrorPage, HomePage } from '@/page';

import adminSettingRoute from './adminSettingRoute';
import apiKeyRoute from './apiKeyRoute';
import authRoute from './authRoute';
import collectionRoute from './collectionRoute';
import deploymentRoute from './deploymentRoute';
import helpRoute from './helpRoute';
import labelingRoute from './labelingRoute';
import modelingRoute from './modelingRoute';
import myWorkRoute from './myWorkRoute';
import projectRoute from './projectRoute';
import userRoute from './userRoute';

const routes: RouteObject[] = [
  {
    path: '',
    Component: HomePage,
    ErrorBoundary: ErrorPage,
    children: [
      ...adminSettingRoute,
      ...authRoute,
      ...apiKeyRoute,
      ...collectionRoute,
      ...deploymentRoute,
      ...helpRoute,
      ...modelingRoute,
      ...labelingRoute,
      ...myWorkRoute,
      ...projectRoute,
      ...userRoute,

      {
        path: '/landing',
        Component: () => {
          const [searchParams] = useSearchParams();

          useEffect(() => {
            location.replace(
              import.meta.env.DEV
                ? `/landing/index.html?${searchParams}`
                : `/landing?${searchParams}`,
            );
          }, []);

          return createElement(Fragment);
        },
      },
    ],
  },
];

export default routes;
